import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { clearAnsweres } from "../../redux/survey/actions";
import { initLearningSession } from "../../redux/learning/actions";
import { useLearningQuery } from "./useLearningQuery";

/** Survey/L&D session keys only — do not wipe auth, or redux-persist. */
const LEARNING_SESSION_STORAGE_KEYS = [
  "invite_id",
  "company_id",
  "company_url",
  "location",
  "employees",
  "logo",
  "survey",
  "tag_id",
  "creator_id",
  "source",
  "callcenter",
  "question_id",
  "option_id",
  "rfid_tag",
  "override_id",
  "task_id",
  "is_override",
  "override_date",
  "response_user_id",
  "client_connect_id",
  "client_connect_excluded",
  "tmp_response_id",
  "survey_partial_exit",
  "audit",
  "email",
];

function clearLearningSessionStorage() {
  LEARNING_SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

function buildSessionKey({ packageId, userId, surveyId, inviteId }) {
  return [packageId, userId, surveyId, inviteId].join("\0");
}

/** Initializes the L&D Redux session and clears survey answers when the entry URL changes. */
export function useLearningSession() {
  const dispatch = useDispatch();
  const { packageId, userId, surveyId, inviteId } = useLearningQuery();
  const sessionKeyRef = useRef(null);

  useEffect(() => {
    const sessionKey = buildSessionKey({
      packageId,
      userId,
      surveyId,
      inviteId,
    });

    if (sessionKeyRef.current !== sessionKey) {
      clearLearningSessionStorage();
      if (inviteId) {
        localStorage.setItem("invite_id", inviteId);
      }

      dispatch(clearAnsweres());
      dispatch(initLearningSession({ packageId, userId, surveyId, inviteId }));
      sessionKeyRef.current = sessionKey;
    }
  }, [dispatch, inviteId, packageId, userId, surveyId]);
}
